import { render, staticRenderFns } from "./PictureUpload.vue?vue&type=template&id=81d9840e"
import script from "./PictureUpload.vue?vue&type=script&lang=ts"
export * from "./PictureUpload.vue?vue&type=script&lang=ts"
import style0 from "./PictureUpload.vue?vue&type=style&index=0&id=81d9840e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports